import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { Post, FollowableUser, ResourcePayload } from 'js/social/shared/types';
import toSnakecaseKeys from 'js/utils/toSnakecaseKeys';
import { Tag } from 'js/social/shared/types';

export const createPost = async ({
  content,
  tags,
  quotableId,
  quotableType,
  image,
  paper,
}: ResourcePayload): Promise<{ post: Post; user: FollowableUser }> => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_post_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content,
        tags: tags.map(toSnakecaseKeys),
        quotable_id: quotableId,
        quotable_type: quotableType,
        image_id: image?.id,
        work_id: paper?.id,
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to create post');
  }
  return await response.json();
};

export const editPost = async (
  postId: string | number,
  content: string,
  tags: Tag[],
): Promise<{ post: Post; user: FollowableUser }> => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_post_path({
      subdomain_param: 'api',
      id: postId,
    }),
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content: content,
        tags: tags.map(toSnakecaseKeys),
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to edit post');
  }

  return await response.json();
};

export const deletePost = async (postId: number | string) => {
  // Spammers get rate-limited "spoofed" comments with ID 0
  if (!postId) return;

  const response = await fetchWithCsrf(
    routes.api_v0_community_post_path({
      subdomain_param: 'api',
      id: postId,
    }),
    { method: 'DELETE' },
  );
  if (response.status !== 204) {
    throw new Error('Failed to delete post');
  }
};
